export const osanoPreload = () => 
  (function (w, o, d) {
    w[o] =
        w[o] ||
        function () {
            w[o][d].push(arguments);
        };
    w[o][d] = w[o][d] || [];
})(window, 'Osano', 'data');;


/**
 * This is a helper function to log Osano events to the console for debugging purposes. It should be called after Osano has been initialized.
 */
export const osanoDebug = () => {
    if (!window.Osano) {
        console.warn('Osano is not initialized. Performing initialization.');
        osanoPreload();
    }
    
    window.Osano('onInitialized', consent => console.log('Osano.js initialized', consent));
            window.Osano('onCookieBlocked', cookie =>
                console.debug('Osano.js blocked cookie:', cookie)
            );
    window.Osano('userData', 'example user data');
}

/**
 * @description This function retrieves the current consent state from Osano. It returns an object containing the consent status for each category of cookies. If Osano is not initialized, it will perform initialization before attempting to retrieve the consent state.
 * @returns {Object} Consent object. See:
 *   https://developers.osano.com/cmp/javascript-api/developer-documentation-consent-javascript-api#the-consent-object
 * @example
 * {
 *   ANALYTICS: "ACCEPT",
 *   MARKETING: "DENY",
 *   PERSONALIZATION: "DENY",
 *   ESSENTIAL: "ACCEPT",
 *   // special IAB categories
 *   "OPT-OUT": "ACCEPT",
 *   STORAGE: "DENY"
 * }
 **/
export const getConsentState = () => {
    if (!window.Osano) {
        console.warn('Osano is not initialized. Performing initialization.');
        osanoPreload();
    }
    
    return window.Osano.cm.getConsent();
}

////////////////////////////////////////////////////////////////
// Helper functions to check specific, non-essential consent categories

export const getAnalyticsConsent = () => {
    const consent = getConsentState();
    return consent.ANALYTICS === 'ACCEPT';
}

export const getMarketingConsent = () => {
    const consent = getConsentState();
    return consent.MARKETING === 'ACCEPT';
}

export const getPersonalizationConsent = () => {
    const consent = getConsentState();
    return consent.PERSONALIZATION === 'ACCEPT';
}

export const invokeOsanoConsentDrawer = () => {
    if (!window.Osano) {
        console.warn('Osano is not initialized. Performing initialization.');
        osanoPreload();
    }
    if (window.Osano && typeof window.Osano.cm.showDrawer === 'function') {
        window.Osano.cm.showDrawer();
    } else {
        console.warn('Osano consent management interface is not available.');
    }
}